import React from "react";
import "./Footer.css";
import { getFM, isPortrait } from "../Utilities/utils";
import { injectIntl } from "react-intl";
import SocialLinks from "./SocialLinks";
import { withRouter } from "react-router";
import { EtermaxBG, RArrowIcon } from "./menu/MenuIcons";
import PropTypes from "prop-types";

function MaxFooter(props) {
  const { staticContext, intl, history, contactsPath, ...footerProps } = props;
  function rights() {
    return (
      <>
        <div className={"rights"}>
          <span>
            <a
              href={
                "https://www.etermax.com/terms/?lang=" +
                intl.locale +
                "#introduction-bg"
              }
            >
              {getFM("footer_terms_and_conditions")}{" "}
            </a>{" "}
          </span>
          <span>
            <a
              href={
                "https://www.etermax.com/privacy/?lang=" +
                intl.locale +
                "#introduction-bg"
              }
            >
              {getFM("footer_privacy_policy")}{" "}
            </a>
          </span>
        </div>
      </>
    );
  }

  function sections() {
    return (
      <div className={"footer-sections"}>
        <span
          onClick={() => history.push("/")}
          className={"footer-section accessibility-font"}
        >
          <span className={"section-text"}>{getFM("footer_home")}</span>
          <RArrowIcon className="footer-right-arrow" />
        </span>
        <span
          onClick={() => history.push("/services/")}
          className={"footer-section accessibility-font"}
        >
          <span className={"section-text"}>{getFM("footer_services")}</span>
          <RArrowIcon className="footer-right-arrow" />
        </span>
        <a
          href="https://www.etermax.com/es/news/search"
          className={"footer-section accessibility-font"}
        >
          <span className={"section-text"}>{getFM("footer_blog")}</span>
          <RArrowIcon className="footer-right-arrow" />
        </a>
        <a
          onClick={() => history.push(contactsPath)}
          className={"footer-section accessibility-font"}
          href={contactsPath}
        >
          <span className={"section-text"}>{getFM("footer_contact")}</span>
          <RArrowIcon className="footer-right-arrow" />
        </a>
      </div>
    );
  }

  return (
    <footer {...footerProps}>
      {isPortrait() ? (
        <>
          {sections()}
          <div className={"footer-company override-decorator"}>
            {rights()}
            <SocialLinks bColor={"white"} bgColor={"transparent"} />
            <div id={"retermax"} className={"rights"}>
              <span>©2021 ETERMAX. ALL RIGHTS RESERVED.</span>
            </div>
          </div>
        </>
      ) : (
        <>
          <div className={"footer-company override-decorator"}>
            <EtermaxBG className={"etermax-icon"} />
            <SocialLinks bColor={"black"} bgColor={"black"} />
            {rights()}
            <div id={"retermax"} className={"rights"}>
              <span>©2021 ETERMAX. ALL RIGHTS RESERVED.</span>
            </div>
          </div>
          {sections()}
        </>
      )}
    </footer>
  );
}

MaxFooter.propTypes = {
  contactsPath: PropTypes.string,
};

MaxFooter.defaultProps = {
  contactsPath: "/contact/",
};

export default withRouter(injectIntl(MaxFooter));
